export const mutations = {
  setLoading(state, value) {
    state.loading = value;
  },

  setAgencyProfile(state, info) {
    state.agencyProfile = info;
  },

  updateLocation(state, payload) {
    state.agencyProfile[payload.key] = payload.value;
  },

  setCategories(state, categories) {
    state.categories = categories;
  },

  setSettings(state, settings) {
    state.settings = settings;
  },
};
